

// This function is used to get the error message from the GraphQL error
import {isAndroid, isIOS} from "./navigator";

export function getGraphQLErrorMsg(errMsg) {
    return errMsg.replace(/^GraphQL error:\s*/i, "")
        .replace(/^Error:\s*/i, "")
        .replace(/^Validation error:\s*/i, "");
}

export function convertCondition(condition) {
    const conditionObj = {
        'NEW': '새상품',
        'GOOD_CONDITION': '아주 좋은 상태',
        'LIGHTLY_WORN': '약간의 사용감',
        'WORN': '사용감 있음',
    };
    return  conditionObj[condition];
}

//비로그인 상태에서 로그인 후 이동할 경로를 저장
export function saveAfterLoginPath(path) {
    sessionStorage.setItem('afterLoginPath', path);
}

//로그인 후 이동할 경로를 가져옴
export function redirectAfterLogin() {
    const afterLoginPath = sessionStorage.getItem('afterLoginPath');
    if (afterLoginPath) {
        sessionStorage.removeItem('afterLoginPath');
    }
    return afterLoginPath;
}

//로그인 후 이동할 경로 삭제
export function removeAfterLoginPath() {
    sessionStorage.removeItem('afterLoginPath');
}

export function convertGender(gender) {
    const genderObj = {
        'MEN': '남자',
        'WOMEN': '여자',
        'UNISEX': '유니섹스',
    };
    return  genderObj[gender];
}

//앱을 열어보고 n초 후에 액션을 실행
export function openAppAndAction( action, specialUrl, delay = 3000) {
    //앱을 딥링크 형태로 열어본다.
    const userAgent = window.navigator.userAgent;
    if (isIOS(userAgent) || isAndroid(userAgent)) {
        const url = specialUrl ? specialUrl : window.location.pathname;
        window.location.href = `fruitsfamily:/${url}`;

        setTimeout(() => {
            action();
        }, delay);
    } else {
        action();
    }
}

//32비트 정수 범위 내에 있는지 확인
export function isWithinInt32Range(value) {
    const MIN_INT32 = -2147483648;
    const MAX_INT32 = 2147483647;
    return Number.isInteger(value) && value >= MIN_INT32 && value <= MAX_INT32;
}

//hostname 별 meta tag robots value
export function getRobotsMetaTag(hostname) {
    switch (hostname) {
        case 'localhost':
        case 'staging.fruitsfamily.com':
            return 'noindex';
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            return 'index';
        default:
            return 'index';
    }
}

//hostname 별 토스 클라이언트키 설정
export function getTossClientKey(hostname) {
    switch (hostname) {
        case 'localhost':
        case 'staging.fruitsfamily.com':
            return 'test_gck_nRQoOaPz8LzX51edA6NzVy47BMw6';
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            return 'live_gck_6BYq7GWPVvNa2An0kZD5VNE5vbo1';
        default:
            return 'test_gck_nRQoOaPz8LzX51edA6NzVy47BMw6';
    }
}

//hostname 별 production url 인지 체크
export function isProductionUrl(hostname) {
    switch (hostname) {
        case 'localhost':
        case 'staging.fruitsfamily.com':
            return false;
        case 'production.fruitsfamily.com':
        case 'fruitsfamily.com':
        case 'www.fruitsfamily.com':
            return true;
        default:
            return false;
    }
}

const KOREAN_NUMBER_FORMATTER = new Intl.NumberFormat('ko-KR');

function toNumericValue(value) {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : NaN;
    }

    if (typeof value === 'string') {
        const normalized = value.replace(/,/g, '').trim();
        if (!normalized) return NaN;
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : NaN;
    }

    return NaN;
}

// 숫자만 추출하는 함수
export const convertOnlyNumber = (value) => {
    if (!value) return 0;
    return parseInt(value.toString().replace(/[^0-9]/g, ''), 10) || 0;
};

// , 를 찍는 함수
export const convertCommaNumber = (param) => {
    if (param === 0) return "0";
    if (!param) return "";

    const numericValue = toNumericValue(param);
    if (!Number.isFinite(numericValue)) return "";

    return KOREAN_NUMBER_FORMATTER.format(numericValue);
};

// 예상 거래 수수료
export const calculateEstimatedAmount = (feeAssigned, currentPrice, shippingFee, feeWavedUntil) => {
    const CARD_FEE = 0.0385;
    const price = convertOnlyNumber(currentPrice);
    const fee = convertOnlyNumber(shippingFee);

    const today = new Date();
    const isFeeWaved =
        feeWavedUntil &&
        new Date(feeWavedUntil) >= new Date(today.setHours(0, 0, 0, 0));
    
    if (feeAssigned === 'BUYER' || isFeeWaved) {
        return Math.floor(price + fee);
    } else {
        return Math.floor(
            (price + fee) * (1 - CARD_FEE)
        );
    }
};

export const formatPrice = (price) => {
    const numericValue = toNumericValue(price);
    if (!Number.isFinite(numericValue)) return "";

    return KOREAN_NUMBER_FORMATTER.format(numericValue);
};
